import { gql, useQuery } from '@apollo/client';

export const GET_PROJECTS_BY_GANTT = gql`
  query getProjectsByGanttId($ganttId: String!) {
    getProjectsByGanttId(ganttId: $ganttId) {
      _id
      createdAt
      createdBy
      name
      startDate
      projectNumber
      plannedHours
      status
    }
  }
`;

export const useGetProjectsByGantt = (ganttId: string | undefined) => {
  const { data, loading } = useQuery(GET_PROJECTS_BY_GANTT, {
    variables: { ganttId },
    skip: !ganttId,
  });

  const projects = data?.getProjectsByGanttId || [];

  return { projects, loading };
};
